module.exports = __webpack_public_path__ + "img/AI_note.f54b3f15.svg";